import {Environment, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import * as tracking from '../../../tracking';
import {trackAndCommitMutation} from '../../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	UpdateCustomFieldDropdownOptionsInput,
	UpdateCustomFieldDropdownOptionsMutation,
} from './__generated__/UpdateCustomFieldDropdownOptionsMutation.graphql';

const mutation = graphql`
	mutation UpdateCustomFieldDropdownOptionsMutation($input: UpdateCustomFieldDropdownOptionsInput!) {
		updateCustomFieldDropdownOptions(input: $input) {
			options {
				id
				displayName
			}
		}
	}
`;

function getOptimisticResponse(input: UpdateCustomFieldDropdownOptionsInput) {
	return {
		updateCustomFieldDropdownOptions: {
			options: input.options.map(option => ({
				id: option.id,
				displayName: option.displayName,
			})),
		},
	};
}
function commit(
	environment: Environment,
	input: MutationInput<UpdateCustomFieldDropdownOptionsInput>,
	onSuccess: RelayOnCompleted<UpdateCustomFieldDropdownOptionsMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinitionDropdownOptions - Updated');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
